import React from 'react'

import RelationsCollection from "../../../model2/relation/collection"
import RelatedItemsControlButton from "./control-button"
import {RelatedItemAddHandler} from "../common/add-menu"
import {createRelatedItem} from "../../../model2/relation/actions/create-related-item"
import {removeRelatedItem} from "../../../model2/relation/actions/remove-related-item"
import addRelationModal from "../../../gd-modals/relations/add-relation-modal"
import {MentionOption} from "../../editor/plugins/mentions/option"

type Props = {
    relations           : RelationsCollection
    canEdit             : boolean

    // The document/page/board's own project, if any -- expands it (and its
    // parents) in the entity selector's Task/Project tabs.
    projectId?          : ID

    className?          : string
    onTogglePopover?    : {(value: boolean): void}
}

// The Related Items control button WITH its add / remove wiring, for the hosts
// whose owner is a document -- the document view, the project page view and the
// project whiteboard. All three wire it identically, so it lives here once
// instead of three times.
//
// `control-button.tsx` itself stays callback-only on purpose: the task and the
// meeting put the confirm dialog at a different layer, so they cannot share this
// (see docs/code/related-items.md).
export default function RelatedItemsDocumentControlButton(props: Props) {

    const {relations} = props

    const onAdd: RelatedItemAddHandler = (entityType) =>
        addRelationModal((entity: MentionOption) => {
            return createRelatedItem(relations, entity)
        }, entityType, props.projectId)

    // removeRelatedItem owns its own confirm.
    const onRemove = (id: ID) => {
        return removeRelatedItem(relations, id)
    }

    return (
        <RelatedItemsControlButton
            className           = {props.className}
            relations           = {relations}
            canEdit             = {props.canEdit}
            onAdd               = {onAdd}
            onRemove            = {onRemove}
            onTogglePopover     = {props.onTogglePopover}
        />
    )
}
